module.exports = __webpack_public_path__ + "static/media/LBFL_Mother-Language-Day-2017-Press_Output.35a79d5c.jpg";